import { Status, IExperimentsQueryFilterParams } from './types';
import { JobState } from '@biolibtech/biolib-js';
import { IExperiment } from '../../apiHooks/experimentApi.types';

export function getExperimentFiltersFromQueryParams(): IExperimentsQueryFilterParams {
    const pageUrl: null | URL = typeof window === 'undefined' ? null : new URL(location.href);
    if (!pageUrl) {
        return { search: '', status: '', ordering: '' };
    }
    return {
        search: pageUrl.searchParams.get('search') ?? '',
        status: pageUrl.searchParams.get('status') ?? '',
        ordering: pageUrl.searchParams.get('ordering') ?? '',
    };
}

export function createExperimentUrlWithNewParams(newParams: Partial<IExperimentsQueryFilterParams>): string {
    const { search, status, ordering } = getExperimentFiltersFromQueryParams();
    const newSearch = newParams.search?.trim() ?? search;
    const newStatus = newParams.status ?? status;
    const newOrdering = newParams.ordering ?? ordering;

    if (newSearch !== search || newOrdering !== ordering || newStatus !== status) {
        const params: string[] = [];
        if (newSearch) {
            params.push(`search=${newSearch}`);
        }
        if (newStatus) {
            params.push(`status=${newStatus}`);
        }
        if (newOrdering) {
            params.push(`ordering=${newOrdering}`);
        }
        return `?${params.join('&')}`;
    }
    return '';
}

export function experimentFromIndex(
    pageMap: Record<number, IExperiment[]>,
    index: number,
    pageSize: number,
): IExperiment | null {
    const pageIndex = Math.floor(index / pageSize);
    const resultIndex = index % pageSize;
    if (pageIndex in pageMap && pageMap[pageIndex].length > resultIndex) {
        return pageMap[pageIndex][resultIndex];
    }
    return null;
}

export const statusToState = {
    [Status.cancelled]: JobState.cancelled,
    [Status.completed]: JobState.completed,
    [Status.error]: JobState.failed,
    [Status.running]: JobState.inProgress,
};
